/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Initiate Swiper on swiper elements
	jQuery('.home-hero .swiper-container').each(function(index, element){
		jQuery(this).addClass('swiper'+index);
		var mySwiper = new Swiper('.swiper'+index, {
			init: false,
			autoplay: {
				delay: 5000,
			},
			loop: true,
			effect: 'fade',
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			preloadImages: false,
			lazy: true,
		});
		mySwiper.init();
	});

	jQuery('.entry-featured .swiper-container').each(function(index, element){
			jQuery(this).addClass('swiper'+index);
			var mySwiper = new Swiper('.swiper'+index, {
				init: false,
				loop: true,
				effect: 'fade',
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				preloadImages: false,
				lazy: true,
			});
			mySwiper.init();
	});
	
	jQuery('.block-image-gallery .swiper-container').each(function(index, element){
		jQuery(this).addClass('swiper'+index);
		var mySwiper = new Swiper('.swiper'+index, {
			init: false,
			loop: true,
			effect: 'fade',
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			preloadImages: false,
			lazy: true,
		});
		mySwiper.on('transitionStart', function() {
			
			jQuery('.swiper'+index).closest('.section').find('.swiper-caption').fadeOut();
		});
		mySwiper.on('transitionEnd', function() {
			var caption = jQuery('.swiper'+index+' .swiper-slide-active').attr('data-caption');
			jQuery('.swiper'+index).closest('.section').find('.swiper-caption').html(caption).fadeIn();
		});
		mySwiper.init();
});
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery('.entry-filters .button').on('click', function(){
		var active = jQuery(this).attr('data-cat');
		jQuery('.entry-filters .button').removeClass('active');
		jQuery(this).addClass('active'); 
		
		if(active == "all") {
			jQuery('.entry-list [data-filter]').fadeIn();
		} else {
			jQuery('.entry-list [data-filter]').each(function() {
				if(jQuery(this).hasClass(active)) {
					jQuery(this).fadeIn();
				} else {
					jQuery(this).hide();
				}
			});
		}
		
	})
	
	
}); 